import React, { Component } from "react"
import { Grid } from "react-styled-flexboxgrid"
import { ThemeProvider } from "styled-components"
import { PoseGroup } from "react-pose"
import { inject, observer } from "mobx-react"

import FadeAndExpand from "~/components/pose/FadeAndExpand"
import TableHeader from "./TableHeader"
import TicketDetailRow from "./TicketDetailRow"

const theme = {
  flexboxgrid: {
    gridSize: 18,
    gutterWidth: "0.5",
    outerMargin: "0",
    mediaQuery: "only screen",
    container: {
      sm: 46,
      md: 61,
      lg: 76
    },
    breakpoints: {
      xs: 0,
      sm: 48,
      md: 64,
      lg: 75
    }
  }
}

@inject(all => ({
  fightSelected: all.store.parkingFlow.results.fightSelected,
  paySelected: all.store.parkingFlow.results.paySelected,
  isUserPreferredFightOrPay: all.store.parkingFlow.flow.isUserPreferredFightOrPay
}))
@observer
class DetailsTable extends Component {

  render() {
    const { fightSelected, paySelected, isUserPreferredFightOrPay } = this.props
    const ticketsToShow = isUserPreferredFightOrPay ? paySelected : fightSelected
    return (
      <ThemeProvider theme={theme}>
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            width: "100%"
          }}
        >
          <TableHeader />
          <PoseGroup flipMove>
            {  ticketsToShow
              ?  ticketsToShow.map(ticket => (
                <FadeAndExpand key={ticket.ticketID}>
                  <TicketDetailRow ticket={ticket} />
                </FadeAndExpand>
                ))
              : null}
          </PoseGroup>
        </Grid>
      </ThemeProvider>
    )
  }
}

export default DetailsTable
